import { useCallback } from 'react';

import { useConversationActions } from '@web/conversations/Conversation/ConversationProvider/ConversationProvider';
import { useUnmuteConversation } from '@web/conversations/hooks/useUnmuteConversation';

type Props = {
  id: number;
};

export const useUnmuteConversationAction = () => {
  const mutation = useUnmuteConversation();
  const { unmuteConversation } = useConversationActions();

  const { mutateAsync } = mutation;

  const action = useCallback(
    async ({ id }: Props) => {
      await mutateAsync({ id });

      unmuteConversation({ id });
    },
    [mutateAsync, unmuteConversation]
  );

  return { action, mutation };
};
